import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { Box, Button } from '@mui/material'
import ErrorLoading from '../components/layout/ErrorLoading'
import CenterLoader from '../components/spinners/CenterLoader'
import '../styles/stores.css'
import { CATALOGUES } from '../graphql/products'
import AddCatalogue from '../components/products/AddCatalogue'
import CataloguesView from '../components/products/CataloguesView'
import NoData from '../components/layout/NoData'

export default function Catalogues() {
  const [catalogues, setCatalogues] = useState(null)
  const [addModalOpen, toggleAddModal] = useState(false)

  const { loading, refetch, error } = useQuery(CATALOGUES, {
    fetchPolicy: 'cache-and-network',
    variables: {
      offset: 0,
      limit: 100,
    },
    onCompleted: ({ catalogues: fetchedCatalogues }) => {
      setCatalogues(fetchedCatalogues)
    },
  })

  const addNewCatalogue = () => {
    refetch().then(({ data }) => {
      setCatalogues(data.catalogues) // Update the state with the refetched catalogues
    })
  }

  const updateCatalogue = (catalogue) => {
    const updatedCatalogues = catalogues.map((c) => (c.id === catalogue.id ? catalogue : c))
    setCatalogues(updatedCatalogues)
  }

  return (
    <div className="page-content">
      <Box sx={{
        my: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}
      >
        <div className="page-tittle no-margin">Product Catalogues</div>
        <Button variant="contained" onClick={() => { toggleAddModal(true) }}>Create Catalogue</Button>
      </Box>
      {addModalOpen ? (
        <AddCatalogue
          close={() => { toggleAddModal(false) }}
          add={addNewCatalogue}
          update={updateCatalogue}
        />
      ) : null}
      <CenterLoader visible={loading} />
      <ErrorLoading visible={error && !loading} reload={refetch} />
      {!loading && !error && catalogues
        ? <CataloguesView catalogues={catalogues} deleteCatalogue={(id) => setCatalogues(catalogues.filter((el) => el.id !== id))} /> : null}
      <NoData visible={!loading && !error && !catalogues?.length} />
    </div>
  )
}
